<template>
  <v-alert
    text
    color="#BF0000"
    type="error"
    class="top-spaced-item multi-line custom-alert pb-0 pl-14 mb-8"
    :icon="false"
    v-if="type === 'phenotypes'"
  >
    <p>
      We're having trouble loading the list of HPO terms. Please continue to
      submit your request and a member of our team will reach out to you to
      regarding the relevant HPO terms. Thank you for your understanding.
    </p>
  </v-alert>
  <v-alert
    text
    color="#BF0000"
    type="error"
    class="top-spaced-item multi-line custom-alert pb-0 pl-14 mb-8"
    :icon="false"
    v-else-if="type === 'genes'"
  >
    <p>
      We're having trouble loading the list of Genes. Please continue to submit
      your request and a member of our team will reach out to you to regarding
      relevant gene candidates. Thank you for your understanding.
    </p>
  </v-alert>
  <v-alert
    text
    color="#BF0000"
    type="error"
    class="top-spaced-item multi-line custom-alert pb-0 pl-14 mb-8"
    :icon="false"
    v-else-if="type === 'genePanels'"
  >
    <p>
      We're having trouble loading the list of Gene panels. Please continue to
      submit your request and a member of our team will reach out to you to
      about the relevant gene panels to be used in analysis. Thank you for your
      understanding.
    </p>
  </v-alert>
</template>

<script>
export default {
  props: {
    type: String,
  },
};
</script>
